// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2BbOU","text":"SelectPayment_text__Zfvkh","title":"SelectPayment_title__3quWK","btn":"SelectPayment_btn__1ComZ"};